import React from 'react';
import styles from './DownloadBtn.module.css';
import { DownloadSvg } from '../../SVGComponents/SVGComponents';

export default function DownloadBtn({ textBtn }) {
  return (
    <button className={styles.btn}>
      <DownloadSvg />
      {textBtn}
    </button>
  );
}
